import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "team",
  class: "py-16 bg-gascon-blue"
}
const _hoisted_2 = { class: "container mx-auto px-4" }
const _hoisted_3 = { class: "relative max-w-5xl mx-auto" }
const _hoisted_4 = { class: "relative rounded-lg overflow-hidden shadow-lg h-72 md:h-80 lg:h-96" }
const _hoisted_5 = { class: "absolute inset-0 bg-gascon-gray" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = {
  key: 1,
  class: "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-24 h-24 text-gascon-blue/30",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_8 = { class: "absolute inset-0 p-4 flex flex-col justify-end text-center bg-gascon-blue/50" }
const _hoisted_9 = { class: "text-lg font-bold text-white mb-1" }
const _hoisted_10 = { class: "text-white/90 text-sm leading-relaxed" }
const _hoisted_11 = { class: "flex justify-center gap-2 mt-4 md:hidden" }
const _hoisted_12 = ["onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.members.length > 0)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "section-title text-white" }, "Nos Gars", -1 /* CACHED */)),
          _createCommentVNode(" Team carousel "),
          _createElementVNode("div", _hoisted_3, [
            _createCommentVNode(" Navigation arrows "),
            ($props.members.length > 3 && $data.canScrollLeft)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = (...args) => ($options.scrollLeft && $options.scrollLeft(...args))),
                  class: "absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 z-10 bg-gascon-gold text-gascon-blue w-10 h-10 rounded-full flex items-center justify-center hover:opacity-80 transition-opacity hidden md:flex"
                }, [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("svg", {
                    class: "w-6 h-6",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M15 19l-7-7 7-7"
                    })
                  ], -1 /* CACHED */)
                ]))]))
              : _createCommentVNode("v-if", true),
            ($props.members.length > 3 && $data.canScrollRight)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  onClick: _cache[1] || (_cache[1] = (...args) => ($options.scrollRight && $options.scrollRight(...args))),
                  class: "absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 z-10 bg-gascon-gold text-gascon-blue w-10 h-10 rounded-full flex items-center justify-center hover:opacity-80 transition-opacity hidden md:flex"
                }, [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("svg", {
                    class: "w-6 h-6",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M9 5l7 7-7 7"
                    })
                  ], -1 /* CACHED */)
                ]))]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Team members container "),
            _createElementVNode("div", {
              ref: "teamContainer",
              class: "flex overflow-x-auto snap-x snap-mandatory scrollbar-hide gap-6 pb-4 px-8 md:px-0",
              onScroll: _cache[2] || (_cache[2] = (...args) => ($options.updateScrollState && $options.updateScrollState(...args)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.members, (member) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: member.id,
                  class: "flex-shrink-0 w-[calc(100%-2rem)] md:w-[calc(33.333%-1rem)] snap-center md:snap-start"
                }, [
                  _createElementVNode("div", _hoisted_4, [
                    _createCommentVNode(" Photo "),
                    _createElementVNode("div", _hoisted_5, [
                      (member.photo_url)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: member.photo_url,
                            alt: member.first_name,
                            class: "w-full h-full object-cover object-top"
                          }, null, 8 /* PROPS */, _hoisted_6))
                        : (_openBlock(), _createElementBlock("svg", _hoisted_7, [...(_cache[5] || (_cache[5] = [
                            _createElementVNode("path", { d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" }, null, -1 /* CACHED */)
                          ]))]))
                    ]),
                    _createCommentVNode(" Info overlay "),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("h3", _hoisted_9, _toDisplayString(member.first_name), 1 /* TEXT */),
                      _createElementVNode("p", _hoisted_10, _toDisplayString(member.description), 1 /* TEXT */)
                    ])
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ], 544 /* NEED_HYDRATION, NEED_PATCH */),
            _createCommentVNode(" Dots indicator (mobile) "),
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.members, (_, index) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: index,
                  onClick: $event => ($options.scrollToMember(index)),
                  class: _normalizeClass(["w-2 h-2 rounded-full transition-colors", $data.currentIndex === index ? 'bg-gascon-gold' : 'bg-white/50'])
                }, null, 10 /* CLASS, PROPS */, _hoisted_12))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}